/**
 * Local (on-device) Computer thread ids carry this prefix so client code and
 * the native request router can recognize them without a server round-trip.
 * On web no thread ever carries the prefix, so every action gate below
 * is a no-op there.
 */
export const LOCAL_THREAD_ID_PREFIX = 'local-';
export const LOCAL_MODEL_PREFERENCE = 'pplx_local';
export function isLocalThreadId(value) {
    return value.startsWith(LOCAL_THREAD_ID_PREFIX);
}
const LOCAL_MODE_SUBMIT_ID_FIELDS = [
    'context_uuid',
    'existing_entry_uuid',
    'frontend_context_uuid',
    'last_backend_uuid',
    'read_write_token',
];
/** Shared Local-submit classification for analytics and transport privacy boundaries. */
export function isLocalModeSubmitParams(params) {
    const submitParams = params;
    if (submitParams.model_preference === LOCAL_MODEL_PREFERENCE)
        return true;
    return LOCAL_MODE_SUBMIT_ID_FIELDS.some((field) => {
        const value = submitParams[field];
        return typeof value === 'string' && isLocalThreadId(value);
    });
}
const CLOUD_THREAD_ACTIONS = {
    archive: true,
    share: true,
    addToProject: true,
    fork: true,
    feedback: true,
    report: true,
};
const LOCAL_THREAD_ACTIONS = {
    archive: false,
    share: false,
    addToProject: false,
    fork: true,
    feedback: false,
    report: false,
};
export function getComputerThreadActions(threadId) {
    return threadId && isLocalThreadId(threadId) ? LOCAL_THREAD_ACTIONS : CLOUD_THREAD_ACTIONS;
}
/**
 * Capability intersection for a multi-thread selection: an action stays
 * available only when every selected thread supports it. An empty selection
 * gates nothing.
 */
export function getCombinedComputerThreadActions(threadIds) {
    const all = threadIds.map(getComputerThreadActions);
    return {
        archive: all.every((actions) => actions.archive),
        share: all.every((actions) => actions.share),
        addToProject: all.every((actions) => actions.addToProject),
        fork: all.every((actions) => actions.fork),
        feedback: all.every((actions) => actions.feedback),
        report: all.every((actions) => actions.report),
    };
}
//# sourceMappingURL=computerThreadActions.js.map